import React from "react";
import { BsCartFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import commonActions from "../Redux/common/actions";
import { LogEvent } from "../utils/firebase";

const ViewCartBtn = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { cartProducts } = useSelector((state) => state.cartReducer);


    const handleCartClick = () => {
        LogEvent("Homemenu_ViewCart");

        if (!localStorage.getItem("token")) {

            dispatch({
                type: commonActions.SET_SHOW_LOGIN_MODAL,
                payload: true,
            });
        }

        else {
            navigate(`/cart?id=${localStorage.getItem("auth_user")}`);
        }
    };

    return (
        <div className="view-cart-floating-btn">
            <button onClick={handleCartClick}>
                <BsCartFill />

                {cartProducts?.order_items?.length > 0 && (
                    <div className="view-cart-count-badge">
                        {cartProducts?.order_items?.length}
                    </div>
                )}
            </button>
        </div>
    );
};

export default ViewCartBtn;